<template>
    <page>
        <module enable-flex ref="view">
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
                    <c-form-item type="input" label="商家名称" name="company_name"></c-form-item>
                    <c-form-item type="input" label="店铺名称" name="shop_name"></c-form-item>
                    <c-form-item type="checkbox" label="状态" name="state" :options="stateType"></c-form-item>
                </c-form>
            </m-search>

            <c-table ref="table" >
<!--                <c-table-column type="selector"></c-table-column>-->
                <c-table-column label="状态" name="state" width="90">
                  <template v-slot="{data}">
                    <span v-if="data.state == 1" style="color:blue">待审核</span>
                    <span v-if="data.state == 2" style="color:green">审核通过</span>
                    <span v-if="data.state == 3" style="color:red">审核驳回</span>
                    <span v-if="data.state == 4" style="color:gray">用户撤销</span>
                  </template>
                </c-table-column>
                <c-table-column
                    label="会员手机号"
                    name="user_manage_mobilephone"
                    width="110"
                ></c-table-column>

                <c-table-column
                    label="会员头像/昵称"
                    name="head_photo"
                    width="180"
                >
                  <template v-slot="{data}">
                    <div class="flex-center-cross">
                      <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                      <span>{{data.nick_name||'--'}}</span>
                    </div>
                  </template>
                </c-table-column>
                <c-table-column  label="商家名称" name="company_name"  width="180">
                </c-table-column>
                <c-table-column
                    label="店铺名称"
                    name="shop_name"
                    width="180"
                ></c-table-column>
                <c-table-column label="店铺地址" name="state" width="300">
                    <template v-slot="{data}">
                        {{data.shop_province_name}} {{data.shop_city_name}} {{data.shop_county_name}} {{data.shop_address}}
                    </template>
                </c-table-column>
                <c-table-column label="联系人" name="contact" width="140">
                </c-table-column>
                <c-table-column label="联系电话" name="contact_phone" width="140">
                </c-table-column>
                <c-table-column label="创建时间" name="create_date" width="140">
                </c-table-column>
                <c-table-column label="撤销时间" name="cancel_date" width="140">
                  <template v-slot="{data}">
                    <span v-if="data.state==4">{{data.cancel_date}}</span>
                  </template>
                </c-table-column>
                <c-table-column label="审核人" name="audit_user" width="140">
                </c-table-column>
                <c-table-column label="审核时间" name="audit_date" width="140">
                </c-table-column>
                <c-table-column  type="button" fixed="right" label="操作"  width="180">
                    <template v-slot="{data}">
                        <c-table-button @click="view(data)">查看</c-table-button>
                        <c-table-button v-if="data.state==1" power="b_srm_stationed_onboarding_audit" @click="auditPass(data)">通过</c-table-button>
                        <c-table-button v-if="data.state==1"  power="b_srm_stationed_onboarding_audit" @click="auditReject(data)">驳回</c-table-button>
                    </template>
                </c-table-column>
        </c-table>
        </module>

        <c-dialog ref="stationedAudit" title="商家入驻审核通过" width="800" @resolve="submitStationedPass">
          <c-form ref="stationedAuditForm">
            <c-form title="基本信息">
              <c-form-item type="input" label="商家名称" name="company_name" maxlength="30" required></c-form-item>
              <c-form-item type="input" label="店铺名称" name="shop_name" maxlength="50"></c-form-item>
              <c-form-item type="region" label="店铺地址"
                             province-name="shop_province_id"
                             city-name="shop_city_id"
                             county-name="shop_county_id"
                             required></c-form-item>
              <c-form-item type="input" name="shop_address" maxlength="150"></c-form-item>
              <c-form-item type="hidden" name="id"></c-form-item>
              <c-form-item type="select" label="商家角色" name="auth_id" options="STANTIONED_AUTH" required></c-form-item>
            </c-form>
            <c-form title="其他信息" unit-width="100%">
<!--              <c-form-item type="select" label="主营类目" name="main_category" options="MAIN_CATEGORIES"></c-form-item>-->
<!--              <c-form-item type="select" label="经营模式" name="management_model" options="MANAGEMENT_MODEL"></c-form-item>-->
              <c-form-item type="textarea" label="店铺介绍" name="shop_content"></c-form-item>
            </c-form>
<!--            <c-form title="补充文件" unit-width="100%">-->
<!--              <c-form-item type="file" label="" name="audit_files" file-type="image,pdf"  word="图片或pdf"></c-form-item>-->
<!--            </c-form>-->
          </c-form>
        </c-dialog>

      <c-dialog ref="stationedAuditReject" title="商家入驻审核驳回" width="650" @resolve="submitStationedReject">
        <c-form ref="stationedAuditRejectForm">
          <c-form-item type="hidden" name="id"></c-form-item>
          <c-form-item type="textarea" label="驳回原因" name="reject_reason" maxlength="30" required></c-form-item>
<!--          <c-form-item type="file" label="补充文件" name="audit_files" file-type="image,pdf"  word="图片或pdf"></c-form-item>-->
        </c-form>
      </c-dialog>

      
		<c-dialog ref="stationedDetail" title="商家入驻信息" width="900" >
		  <c-detail title="基本信息">
        <c-detail-item label="申请会员" name="head_photo">
          <div class="flex-center-cross">
            <c-image :src="detailData.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
            <span>{{detailData.nick_name||'--'}} {{detailData.user_manage_mobilephone}}</span>
          </div>
        </c-detail-item>
        <c-detail-item label="企业名称" name="company_name">{{detailData.company_name}}</c-detail-item>
        <c-detail-item label="店铺名称" name="shop_name">{{detailData.shop_name}}</c-detail-item>
        <c-detail-item label="店铺地址" name="address">{{detailData.shop_province_name}}{{detailData.shop_city_name}}{{detailData.shop_county_name}}{{detailData.shop_address}}</c-detail-item>
        <c-detail-item label="主营业务" name="main_category">{{detailData.main_category}}</c-detail-item>
<!--        <c-detail-item label="经营模式" name="management_model">{{detailData.management_model}}</c-detail-item>-->
        <c-detail-item full label="店铺介绍" name="shop_content">{{detailData.shop_content}}</c-detail-item>
        <c-detail-item label="营业执照" name="" >
          <template v-for="(item, index) in detailData.qualification_file_list">
            <c-image :src="item" preview size="30" style="margin-right: 10px;"></c-image>
          </template>
        </c-detail-item>

		  </c-detail>
      <c-detail title="联系人信息">
        <c-detail-item label="联系人" name="contact">{{detailData.contact}}</c-detail-item>
        <c-detail-item label="联系电话" name="contact_phone">{{detailData.contact_phone}}</c-detail-item>
      </c-detail>

      <c-detail title="审核信息" >
        <c-detail-item label="状态" name="state">
          <span v-if="detailData.state == 1" style="color:blue">待审核</span>
          <span v-if="detailData.state == 2" style="color:green">审核通过</span>
          <span v-if="detailData.state == 3" style="color:red">审核驳回</span>
          <span v-if="detailData.state == 4" style="color:gray">用户撤销</span>
        </c-detail-item>
        <c-detail-item label="申请时间" name="create_date">{{detailData.create_date}}</c-detail-item>
        <c-detail-item v-if="detailData.state==4" label="撤销时间" name="cancel_date">{{detailData.cancel_date}}</c-detail-item>
        <c-detail-item v-if="detailData.state==2||detailData.state==3" label="审核人" name="audit_user">{{detailData.audit_user}}</c-detail-item>
        <c-detail-item v-if="detailData.state==2||detailData.state==3" label="审核时间" name="audit_date">{{detailData.audit_date}}</c-detail-item>
        <c-detail-item v-if="detailData.state==3" label="驳回原因" name="reject_reason">{{detailData.reject_reason}}</c-detail-item>
<!--        <c-detail-item v-if="detailData.audit_files" label="补充文件" name="audit_files">-->
<!--          <c-image :src="detailData.audit_files" preview size="30" style="margin-right: 10px;"></c-image>-->
<!--        </c-detail-item>-->
      </c-detail>

      <template slot="button">
        <c-button size="m" @click="close">关闭</c-button>
      </template>
		</c-dialog>
    </page>
</template>

<script>
	import editProductClassify from '@/pages/product/stationed_product_classify.vue'
    import {mapState} from "vuex";

    export default {
        name: 'm_srm_stationed_onboarding',

        components: {
            editProductClassify
        },
        data() {
            return {
              searchParams:{},
              stationedState:2,
              stateType:[
                  {name:'待审核',value:1},
                  {name:'审核通过',value:2},
                  {name:'审核驳回',value:3},
                  {name:'用户撤销',value:4},
              ],
              auditStateType:[
                {name:'审核通过',value:2},
                {name:'审核驳回',value:3},
              ],
              detailData:{},
            }
        },
		
        computed: {
                ...mapState(['systemConfig', 'userInfo']),
        },

        watch: {

        },

        mounted() {
            this.$refs.search.search();
        },

        methods: {
            searchHandle(data = {}) {
                this.$refs.table.load({
                    url: '/stationed_onboarding/list',
                    data
                });
                this.searchParams = data;
            },

           auditPass(val) {
                var temp =Object.assign({},val);
                temp.address = val.shop_province_name+','+val.shop_city_name+','+val.shop_county_name+','+val.shop_address;

                this.$refs.stationedAuditForm.clear();
                this.$refs.stationedAuditForm.set(temp);
                this.$refs.stationedAudit.open();
            },
            auditReject(val) {
              var temp =Object.assign({},val);
              this.$refs.stationedAuditRejectForm.clear();
              this.$refs.stationedAuditRejectForm.set(temp);
              this.$refs.stationedAuditReject.open();
            },
            view(val) {
              this.detailData = val;
              this.$refs.stationedDetail.open();
            },
            close(val) {
              this.detailData = {};
              this.$refs.stationedDetail.close();
            },

            submitStationedPass(stop) {
                stop();
                this.$refs.stationedAuditForm.submit({
                  url:'/stationed_onboarding/pass',
                  rule: {
                      company_name: '请填写企业名称',
                      shop_county_id: '请选择店铺地址所在省市县信息',
                      shop_address: '请填写店铺详细地址',
                      auth_id: '请选择商家角色',
                  },
                  dataFormatter: data => {
                      data.stationed_type = 1;
                      return data;
                  },
                  success: (data, res, msg) => {
                    this.$confirm({
                      text: msg,  // 提示内容,
                      buttonName: '知道了',  // 确定按钮文字
                      cancelButton: false  // 是否显示取消按钮
                    });
                    this.$refs.table.update();
                    this.$refs.stationedAudit.close();
                  }
                });
            },
            submitStationedReject(stop) {
              stop();
              this.$refs.stationedAuditRejectForm.submit({
                url: '/stationed_onboarding/reject',
                rule: {
                  reject_reason: '请填写驳回原因',
                },
                dataFormatter: data => {
                  return data;
                },
                success: (data, res, msg) => {
                    this.$message({
                      text: msg,
                      icon: 'success'
                    });
                  this.$refs.table.update();
                  this.$refs.stationedAuditReject.close();
                }
              });
            },
        }
    }
</script>